export default function cleanDate(date) {
  const cleanDate = new Date(date);

  cleanDate.setHours(0, 0, 0, 0);
  return cleanDate;
}
